import React from 'react';
import { useIntl } from 'react-intl';

import { RecordIcon } from 'components/presenters/icons';

interface Props {
  type: string;
  isActiveRecordIcon: boolean;
  defaultMessage: string;
  id: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
  multiple?: boolean;
}

export default function RecordButton({
  type,
  isActiveRecordIcon,
  defaultMessage,
  id,
  onClick,
  className,
  multiple,
}: Props) {
  const intl = useIntl();
  const buttonLabel = intl.formatMessage({ defaultMessage, id });

  return (
    <button data-value={type} aria-label={buttonLabel} onClick={onClick} type='button'>
      <RecordIcon active={isActiveRecordIcon} className={className} multiple={multiple} />
      { buttonLabel }
    </button>
  );
}
